module.exports = {
    gameNetworkId: 526
};


//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 28
// module chunks = 0